import { FieldContinuationData, FieldContinuationDataForResolver, FieldTemplate, FieldTemplateForResolver, Option } from "../db/definitions";
import batchGetFieldContinuationDataByFormTemplate from "./batchGetFieldContinuationDataByFormTemplate";
import batchGetFieldTemplatesByFormTemplate from "./batchGetFieldTemplatesByFormTemplate";
import batchGetOnlyFieldTemplatesByFormTemplate from "./batchGetOnlyFieldTemplatesByFormTemplate";
import batchGetOptionsByFormTemplate from "./batchGetOptionsByFormTemplate";

/**
 * This is in charge of handling determining if documents need to be deleted from the respective db
 * then returns an array of documents for deletion
 */
export async function handleDeletionOfExistingDocuments({
	documents,
	docType,
	listOfKeepers,
	formTemplateId,
	online,
}: {
	documents: FieldTemplate[] | Option[];
	docType: string;
	listOfKeepers: string[];
	formTemplateId: string;
	online: boolean;
}) {
	let docsToDelete = [];
	// First retrieve all the existing options by form template.
	const existingDocuments = await retrieveDocsByType({ docType, formTemplateId, online });

	// Make a map of these
	// Loop through the documents and if the option exists in the map, but not in the listOfKeepers
	for (let i = 0; i < existingDocuments.length; i++) {
		const documentToCheck = existingDocuments[i];
		const existsInListOfKeepers = listOfKeepers.includes(documentToCheck.id);
		if (!existsInListOfKeepers) {
			// TO BE DELETED!!!
			// Then it is one that needs to be deleted from the respective db
			docsToDelete.push(documentToCheck);
		}
	}

	return docsToDelete;
}

/**
 * retrieves the provided types (either option or field template) based on the form template id.
 * @param docType string for the model type
 * @param formTemplateId id for the form template
 */
async function retrieveDocsByType({ docType, formTemplateId, online }: { docType: string; formTemplateId: string; online: boolean }) {
	// let docs: any[] = [];
	switch (docType) {
		case "Option":
			let optionDocs: Option[] = [];
			optionDocs = await batchGetOptionsByFormTemplate(formTemplateId, online);
			// docs = retrievedOptions;
			return optionDocs;
		case "FieldTemplate":
			let templateDocs: FieldTemplateForResolver[] = [];
			templateDocs = await batchGetOnlyFieldTemplatesByFormTemplate(formTemplateId, online);
			// docs = retrievedFieldTemplates.fieldTemplates;
			return templateDocs;
		case "FieldContinuationData":
			let contDocs: FieldContinuationDataForResolver[] = [];
			contDocs = await batchGetFieldContinuationDataByFormTemplate(formTemplateId, online);
			return contDocs;
		default:
			// if the table isnt recognized then there is nothing to be done here
			return [];
	}
}

/**
 * Basically the same as handleDeletionOfExistingDocuments, except this is typed specifically for FieldContinuationData.
 * I am sure there is a fancier way to do this, but this will work for now.
 * @param listOfKeepers In this case, this will be an array of fieldContinuationData.id, and we will determine if its a keeper field cont via the continuations id.
 * @param formTemplateId of the form template these belong to
 * @param online boolean for that
 * @returns list of the continuationData that need to be deleted
 */
export async function handleDeletionOfExistingFieldContinuation({
	listOfKeepers,
	formTemplateId,
	online,
}: {
	listOfKeepers: string[];
	formTemplateId: string;
	online: boolean;
}) {
	let docsToDelete = [];
	// First retrieve all the existing options by form template.
	const existingDocuments: FieldContinuationDataForResolver[] = (await retrieveDocsByType({
		docType: "FieldContinuationData",
		formTemplateId,
		online,
	})) as FieldContinuationDataForResolver[];
	// Make a map of these
	// Loop through the documents and if the option exists in the map, but not in the listOfKeepers
	for (let i = 0; i < existingDocuments.length; i++) {
		const documentToCheck = existingDocuments[i];
		const existsInListOfKeepers = listOfKeepers.includes(documentToCheck.id);
		if (!existsInListOfKeepers) {
			// add the continuation data to the docs to delete with the batch deletion later on.
			docsToDelete.push(documentToCheck);
		}
	}
	return docsToDelete;
}

export default handleDeletionOfExistingDocuments;
